import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import { toastError, toastSuccess } from "../../../../../customComponents/customToast/Toast";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";

const AddNewCustomer = () => {
  const [formData, setFormData] = useState({});
  const authToken = localStorage.getItem("authToken");
  const businessPartnerId = 1
  const [responseerrormessage,setResponseErrorMessage] = useState('')

  const [activeSection, setActiveSection] = useState('customer');

  const [ businessPartnertypedd, setBusinessPartnerTypedd ] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [validationErrors, setValidationErrors] = useState({});

  const [isMainFormSubmitted, setIsMainFormSubmitted] = useState(false);
  // const [isDocumentFormSubmitted, setIsDocumentFormSubmitted] = useState(false);
  const navigate = useNavigate();
  // const handleFormSubmit = (data) => {
  //   setIsMainFormSubmitted(true);
  //   console.log("Form Data:", data);
  // };

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  const handleNavigate = () => {
    navigate('/admin/manage-onboard/onboard/create-agent');
  };
  
  const handleFormSubmit = async (formData) => {

    const errors = {};
    let isValid = true;

    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    setIsLoading(true);

    showCustomAlert({
      title: "Success",
      text: "Do you want to create this record?",
      icon: "success",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      callback: async () => {
    
    try{
      const resposne = await axiosInstance.post("/bp-onboard/create",{
        onboard_process_type:formData.onboard_process_type,
        bp_type:formData.business_partner_type,
        bp_name:formData.bp_name,
        contact_no:formData.contact_no,
        email_id:formData.email_id,
        pincode:formData.pincode,
        city_id:formData.city_id,
        country_id:formData.country_id,
        state_id:formData.state_id,
        bp_address:formData.bp_address,
        onboard_status:1,
        gst_no:formData.gst_no,
        status: formData.status=="Active"?1:0,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      console.log("API Response:", resposne.data);
      // toastSuccess("Product added successfully!");

      if (resposne.status === 200) {
 
        navigate("/admin/manage-onboard/onboard")

  }
    }catch (error) {
      console.log(error, "error");
  
      if (error.response && error.response.status === 403) {
        const errorMessage = error.response?.data?.message

    showErrorAlert({
      title: "Something went wrong",
      text: errorMessage || "An error occurred while processing your request.",
      callback: () => { 
        // Optional: code to execute after confirming the alert
        console.log("Error alert confirmed");
      }
    });
        // toastError(errorMessage);
      } else {
        // toastError("Failed to Add Data. Please try again.");
      }
    }finally{
      setIsLoading(false)
    }
  },
});
  }

  const fetchBusinessPartnerType = async () => {
    try{
   const resposne = await axiosInstance.post("/businesspartnertype/ddlbusinesspartnertype",{},{
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    }
  })
  const options = resposne.data.data.data.map( data => ({
    label: data.NAME,
    value: data.ID,
  }));

  setBusinessPartnerTypedd(options)

    }catch(error){
      console.log(error)
    }
  }


  useEffect(() => {
fetchBusinessPartnerType();
  },[])

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      onboard_process_type: "customer"
    }));
  }, []);

  const CustomerInputs = [
    {
      name: "onboard_process_type",
      label: "On Board Business Type",

      type: "hidden",
      required: true,
      // options: options,
      options: [
        { label: "customer", value: "customer" },
      ],
      // options: [
      //   { label: "OEM", value: "OEM" },
      //   { label: "OEM2", value: "OEM2" },
      // ],
      // gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "business_partner_type",
      label: "Business Partner Type",
      type: "dropdown",
      required: true,
      options: businessPartnertypedd,
      // options: [
      //   { label: "OEM", value: "OEM" },
      //   { label: "OEM2", value: "OEM2" },
      // ],
      disabled:true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "bp_name",
      label: "Business Partner Name",
      placeholder:"Enter Business Partner Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, pattern: /^[A-Za-z0-9\'\-.,&()[\]]+(?:\s[A-Za-z0-9\'\-.,&()[\]]+)*$/,
        message: "Only alphanumeric characters, specific symbols, and single spaces between words are allowed*", maxLength:50}
    },
    {
      name: "contact_no",
      label: "Contact No.",
      placeholder:"Enter Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      }
    },
    {
      name: "email_id",
      label: "Email Address",
      placeholder:"Enter Email Address",
      type: "email",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ , message: "Please enter a valid Email Address"},
    },
    {
      name: "bp_address",
      label: "Business Partner Address",
      placeholder:"Enter Business Partner Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true ,maxLength:50},
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder:"Enter Pincode",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true , maxLength:6, pattern:/^[1-9][0-9]{5}$/,message:"Invalid Pin Code",responseerrormessage:responseerrormessage}
    },
    {
      name: "city",
      label: "City",
      placeholder:"City",
      type: "text",
      gridClass: "col-lg-4",
      required: false,
      //validation: { required: true },
      disabled:true
    },
    {
      name: "state",
      label: "State",
      placeholder:"State",
      type: "text",
      required: false,
      gridClass: "col-lg-4",
     // validation: { required: true },
      disabled:true
    },
    {
      name: "country",
      label: "Country",
      placeholder:"Country",
      type: "text",
      required: false,
      gridClass: "col-lg-4",
      //validation: { required: true },
      disabled:true
    },
    {
      name: "gst_no",
      label: "GST No.",
      placeholder:"Enter GST No.",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      validation: { 
        // required: true, 
        pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/, 
        message: "Please enter a valid 15-character GST number",
        maxLength:15
      },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id:1, label: "Active", value: "Active" },
        { id:0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "action",
      label: "Action",
      required: true,
      type: "dropdown",
      options: [
        { label: "New", value: "New" },
        // { label: "Update", value: "Update" },
        // { label: "Approve", value: "Approve" },
      ],
      disabled:true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      onboard_process_type: "customer",
      action:"New",
      business_partner_type:1
    }));
  }, []);

  const backNavigate = () => {
    navigate("/admin/manage-onboard/onboard")
  }

  return (
    <>
      <div className="backbutton mt-2 mb-2">
        <img onClick={backNavigate}  src={backicon} alt="back" />
        <span className="backbtntitle">Add New Business Partner</span>
      </div>
      <div className="form-container">
        <div style={{display:"flex", gap:"10px"}}>
      <button 
            className={`OnboardManagamentButtons ${activeSection === 'customer' ? 'onboardactive' : ''}`} 
            onClick={() => handleSectionChange('customer')}
          >
            Customer
          </button>
          <button 
            className={`OnboardManagamentButtons ${activeSection === 'Agent' ? 'onboardactive' : ''}`} 
            // onClick={() => handleSectionChange('Agent')}
            onClick={handleNavigate}
          >
            Agent
          </button>
        </div>
        <div className="cust-det-title mt-2 mb-2">
          Please Enter Customer Details
        </div>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          setResponseErrorMessage={setResponseErrorMessage}
        />
      </div>
      {/* {isMainFormSubmitted && (
        <div className="mt-5">
          <h5 className="mt-5 mb-3">Upload Documents and Details</h5>
          <DynamicForm
            formConfig={CustomerInputsAfterSuccess}
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleDocumentFormSubmit}
          />
        </div>
      )} */}

      <div className="btncontainer mt-3">
        <button
          // onClick={() => {
          //   if (!isMainFormSubmitted) {
          //     handleFormSubmit(formData); // Call handleFormSubmit if isMainFormSubmitted is false
          //   } else {
          //     // Merge document form data with existing formData
          //     navigate("/admin/onboard/customer-details", {
          //       state: { formData },
          //     }); // Navigate to another route if isMainFormSubmitted is true
          //   }
          // }}
          onClick={() => {
   
            handleFormSubmit(formData); 
        }}
          className="submit-btn"
        >
          Submit
          {/* {isLoading ? "Submitting..." : "Submit"} */}
        </button>
      </div>
    </>
  );
};

export default AddNewCustomer;
